/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useInputValue } from '../../utils/hooks/useInputValue';
import { Utils, Teams, Auth, User } from '../../utils/api';
import { ARMcontext } from '../../utils/context/context';
import {
  Navbar,
  FluidContainer,
  LargeButton,
  Label,
  InputComponent,
  BadgeImage,
  Loader,
  ToolTip,

} from '../../components';
import {
  CRightTop,
  ConfigCard,
 CLeftBadges,
  CLeftActions,
  CRightBottom,
  ConfigWrapper,
  ConfigCardLeft,
  ConfigCardRight,
  CLeftActionInfo,
  CRightInputWrapper,
  InputWrapper,
  TopWrapper,
  BottomWrapper,
} from './styles';


const DefaultStates = [{ name: 'CO' }, { name: 'KA' }, { name: 'WS' }];

export default () => {
  const teamLogoRef = useRef<HTMLInputElement | any>(document.createElement('input'));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [defaultStat, useDefaultStates] = useState<any>(DefaultStates);
  const { HandleToastMessage, HandleUser, user } = React.useContext(ARMcontext);
  
  const [city] = useState<any>(user.data?.city ? { name: user.data?.city } : { name: user.data?.organization?.city });
  const [image, useImage] = useState<any>('');
  
  const [loading, useLoading] = useState(false);
  const [formFilled, useFormFilled] = useState(false);
 
  const EmailInput = useInputValue(user.data ? user.data.email : '');
  const OrganizationInput = useInputValue(
    user.data?.isFirstLogin ? '' : user.data.organization.name ? user.data.organization.name : '',
  );
  const TeamBadge = useInputValue(
    user.data?.organization?.initials ? user.data.organization.initials.slice(0, 2) : user.data.firstName.slice(0, 2),
  );
  const PhoneInput = useInputValue(user.data.phone ? user.data.phone : '');
  const CityInput = useInputValue(user.data.city ? user.data.city : city.name);
  const FNameInput = useInputValue(user.data ? user.data.firstName : '');
  const LNameInput = useInputValue(user.data ? user.data.lastName : '');
  const [error, useError] = useState(false);
  const utils = new Utils();
  const TEAMS = new Teams();
  const AUTH = new Auth();
  const USER = new User();
  const validateEmail = utils.GetValidationEmailPattern();
 const validateInput = utils.GetValidationInputPattern();


  useEffect(() => {
    BuildStates();
  }, []);

  useEffect(() => {
    handleDone();
  }, [image]);

  useEffect(() => {
    TeamBadge.HandleValue(TeamBadge?.value?.toUpperCase() || '');
  }, [TeamBadge.value]);
  

  useEffect(() => {
    let error = 0;
    !validatedEmail() && error++;
    !validatedFirstName() && error++;
    !validatedLastName() && error++;
    
    formFilledCoach(); 

    if (error === 0) {
      useError(false);
    } else {
      useError(true);
    }
  }, [FNameInput.value, LNameInput.value, EmailInput.value, PhoneInput.value, CityInput.value, OrganizationInput.value]);

  function validatedEmail(): boolean {
    if (Number(EmailInput.value.length) === 0 || !Boolean(validateEmail.test(EmailInput.value))) {
      EmailInput.HandleWarning('Please enter a valid email');
      EmailInput.HandleStatus('error');
      return false;
    } else {
      EmailInput.HandleWarning('');
      EmailInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedFirstName(): boolean {
    if (Number(FNameInput.value.length) === 0 || !Boolean(validateInput.test(FNameInput.value))) {
      FNameInput.HandleWarning('Please enter a valid first name');
      FNameInput.HandleStatus('error');
      return false;
    } else {
      FNameInput.HandleWarning('');
      FNameInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedLastName(): boolean {
    if (Number(LNameInput.value.length) === 0 || !Boolean(validateInput.test(LNameInput.value))) {
      LNameInput.HandleWarning('Please enter a valid last name');
      LNameInput.HandleStatus('error');
      return false;
    } else {
      LNameInput.HandleWarning('');
      LNameInput.HandleStatus('normal');
      return true;
    }
  }
 
 

  function formFilledCoach(): void {
    if (FNameInput.value && LNameInput.value && EmailInput.value ) {
      useFormFilled(true);
    } else {
      useFormFilled(false);
    }
  }
 

  async function BuildStates() {
    const result = await TEAMS.GetStates();
    if (result.status) {
      useDefaultStates(result.data);
    }
  }


  function ChangeImage(selectedOption: any) {
    useImage(selectedOption);
  }

 

  function handleUploadTeamLogo() {
    teamLogoRef.current.click();
    teamLogoRef.current.onchange = () => ChangeImage(teamLogoRef.current.files[0]);
  }

  function DeleteTeamLogo() {
    ChangeImage('null');
  }

  function HandleFocus(input: any) {
    input.HandleWarning('');
    input.HandleStatus('normal');
  }

  async function handleDone() {
    if (!error && formFilled) {
      let resultImage: any;
      if (image && image !== 'null') {
        const uploadImage = await utils.UploadFile(image);
        resultImage = uploadImage.data.path;
      } else {
        resultImage = image === 'null' ? image : '';
      }
  
      const form = {
        firstName: FNameInput.value,
        lastName: LNameInput.value,
        email: EmailInput.value,
        image: resultImage,
      };
      useLoading(true);
      const response: any = await AUTH.UpdatePlayerSettings(
        user.data.id,
        form.firstName,
        form.lastName,
        form.email,
       form.image,

      );

      if (response.status) {
        const updatedUser: any = await USER.GetUserData();
        if (updatedUser.status) {
          useLoading(false);
          HandleToastMessage(`UPDATED`, false, 2000, 'success');
          HandleUser(user, updatedUser.data);
        }
      } else {
        useLoading(false);
        HandleToastMessage(response.data.message, false, 2000, 'error');
      }
    }
  }


 function checkTrueUserImage(role): boolean {
  return user.data?.picture && user.data?.picture !== 'null';
  }

  function checkFalseUserImage(role): boolean {
    return user.data?.picture === 'null' || !user.data.picture;
  }

  // function VideoTourCallback(): any {
  //   setVideoTour(false)
  //   if (user.role === 'org-admin') {
  //     HandleToastMessage(`Welcome, please change the initial organization name`, false, 9000, 'success');
  //   }
  // }
  const img = image && image !== 'null' ? URL.createObjectURL(image) : user?.data?.picture || user?.data?.organization?.picture;
  return (
    <>
      <Navbar />
      <ConfigWrapper data-cy="config">
        <FluidContainer>
          <ConfigCard>
            <TopWrapper>
              <ConfigCardLeft>
                {((image && image !== 'null') || (!image && checkTrueUserImage(user.role))) && (
                  <>
                    <CLeftBadges data-cy="badge-picture">
                      <BadgeImage srcImage={img} callback={DeleteTeamLogo} />
                    </CLeftBadges>
                    <CLeftActions empty={false}>
                      <input
                        data-cy="file-input"
                        ref={teamLogoRef}
                        type="file"
                        accept="image/png, image/jpeg"
                        style={{ display: 'none' }}
                      />
                      <LargeButton
                        callback={handleUploadTeamLogo}
                        rColor="#006BE1"
                        lColor="#007AFF"
                        icon="uploadImage"
                        title="UPLOAD NEW PHOTO"
                      />
                      <CLeftActionInfo>You can edit your profile picture or upload a new one (JPG or PNG)</CLeftActionInfo>
                    </CLeftActions>
                  </>
                )}
                {(image === 'null' || (!image && checkFalseUserImage(user.role))) && (
                  <>
                  
                    {user.role === 'player' && (
                      <CLeftBadges data-cy="badge-picture">
                        <BadgeImage srcImage={undefined} callback={DeleteTeamLogo} />
                      </CLeftBadges>
                    )}
                    <CLeftActions empty={true}>
                      <input
                        data-cy="file-input"
                        ref={teamLogoRef}
                        type="file"
                        accept="image/png, image/jpeg"
                        style={{ display: 'none' }}
                      />
                      <LargeButton
                        callback={handleUploadTeamLogo}
                        rColor="#ACB1C0"
                        lColor="#979CA9"
                        icon="uploadImage"
                        title={user.role === 'player' ? 'UPLOAD PROFILE PICTURE' : 'UPLOAD PROFILE PICTURE'}
                      />
                      <CLeftActionInfo>You can edit your profile picture or upload a new one (JPG or PNG)</CLeftActionInfo>
                    </CLeftActions>
                  </>
                )}
              </ConfigCardLeft>
              <ConfigCardRight>
                <CRightTop>
                  <InputWrapper>
                    <Label text="First Name*" />
                    <CRightInputWrapper data-cy="firstname">
                      <InputComponent
                        placeholder={user.data?.firstname ? user.data.firstName : 'First Name'}
                        animateWidth="100%"
                        dynamicSearch={FNameInput}
                        HandleFocus={() => HandleFocus(FNameInput)}
                      />
                    </CRightInputWrapper>
                    {FNameInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={FNameInput.warningMessage} />}
                  </InputWrapper>
                  <InputWrapper>
                    <Label text="Last Name*" />
                    <CRightInputWrapper data-cy="lastname">
                      <InputComponent
                        placeholder={user.data?.lastname ? user.data.lastName : 'Last Name'}
                        animateWidth="100%"
                        dynamicSearch={LNameInput}
                        HandleFocus={() => HandleFocus(LNameInput)}
                      />
                    </CRightInputWrapper>
                    {LNameInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={LNameInput.warningMessage} />}
                  </InputWrapper>
                  <InputWrapper>
                    <Label text="Email*" />
                    <CRightInputWrapper data-cy="email">
                      <InputComponent
                        placeholder={user.data?.email ? user.data.email : 'Email'}
                        animateWidth="100%"
                        dynamicSearch={EmailInput}
                        maxLength={100}
                        HandleFocus={() => HandleFocus(EmailInput)}
                      />
                    </CRightInputWrapper>
                    {EmailInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={EmailInput.warningMessage} />}
                  </InputWrapper>
                
                     </CRightTop>
              </ConfigCardRight>
            </TopWrapper>
            <BottomWrapper>
              {formFilled && !error ? (
                !loading ? (
                  <CRightBottom>
                    <LargeButton callback={handleDone} rColor="#FF3B30" lColor="#E1342A" icon="done" title="SAVE PROFILE" />
                  </CRightBottom>
                ) : (
                  <CRightBottom>
                    <Loader width="186px" height="50px" />
                  </CRightBottom>
                )
              ) : (
                <></>
              )}
            </BottomWrapper>
          </ConfigCard>
        </FluidContainer>
      </ConfigWrapper>
    
      {/* {isVideoTour && (
        <VideoTourModal callback={VideoTourCallback} />
      )} */}
    </>
  );
};
